'use client';

import i18next from 'i18next';
import {
  initReactI18next,
  useTranslation as useTranslationOrg,
  Trans,
} from 'react-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { getOptions } from './settings';
import { locales } from './index';
import type { TFunction } from 'i18next';

const runsOnServerSide = typeof window === 'undefined';

// Initialize i18next on client side
i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(
    resourcesToBackend((language: string, namespace: string) =>
      fetch(`/locales/${language}/${namespace}.json?v=${__APP_VERSION__}`).then((res) => res.json())
    )
  )
  .init({
    ...getOptions(),
    lng: undefined, // let detect the language on client side
    detection: {
      order: ['path', 'htmlTag', 'cookie', 'navigator'],
    },
    preload: runsOnServerSide ? locales : [],
  });

export default i18next;

export function useTranslation(
  ns?: string,
  options: { keyPrefix?: string } = {}
) {
  const ret = useTranslationOrg(ns, options);

  return {
    ...ret,
    i18n: ret.i18n,
    t: ret.t,
  };
}

export { Trans };
export type { TFunction };
